import {
  Breadcrumbs,
  Notification,
  Stack,
} from '@omnipresentgroup/design-system';
import { useExpensesConfig } from '@omnipresentgroup/domains';
import {
  type BaseExpense,
  ExpensesEditingMethod,
} from '@omnipresentgroup/types';
import { useNavigate } from 'react-router';

import { EXPENSES_DETAILS_PATH, HOME_PATH } from '../../constants';
import { ExpensesList } from '../../features/expenses';
import { useManagerUser } from '../../hooks';

export const EXPENSES_PAGE_TITLE = 'Expenses';

const UPLOAD_NOTIFICATION_MESSAGE =
  'Expenses can be uploaded only by managers, manual submission is disabled for employees. If you upload the expenses before the cutoff date, the expenses would be reimbursed in the next payroll cycle.';

const NOTIFICATION_MESSAGE =
  'Important: Review individual employee cutoff dates on the expense details page before approval. If you approve after the current cutoff date, the expense would be reimbursed in the next payroll cycle.';

export const ExpensesPage = () => {
  const navigate = useNavigate();

  const { companyId } = useManagerUser();

  const { data: expensesConfig } = useExpensesConfig();

  return (
    <>
      <Stack gap="16">
        <Breadcrumbs
          crumbs={[
            {
              id: 'home',
              title: 'Home',
              onClick: () => navigate(HOME_PATH),
            },
            {
              id: 'expenses',
              title: EXPENSES_PAGE_TITLE,
              active: true,
            },
          ]}
        />

        <Notification
          id="expenses-alert"
          intent="info"
          title={
            expensesConfig?.editingMethod === ExpensesEditingMethod.UPLOAD
              ? UPLOAD_NOTIFICATION_MESSAGE
              : NOTIFICATION_MESSAGE
          }
        />
      </Stack>

      <ExpensesList
        clientId={companyId}
        columnVisibility={{
          employeeName: true,
          spentAt: true,
          amount: true,
          dateSpent: true,
          appover: true,
          status: true,
        }}
        onRowClick={(row: BaseExpense) => {
          navigate(EXPENSES_DETAILS_PATH(row.id));
        }}
        showFilters
        useRowSelection
        isEditingMethodUpload={
          expensesConfig?.editingMethod === ExpensesEditingMethod.UPLOAD
        }
      />
    </>
  );
};
